module.exports = __webpack_public_path__ + "fc617b28fdfb8a6a180e09fee0c7b482.svg";